import React, { useState, useContext } from 'react';
import { Flex, Modal } from '@flightstats/airframe-react';

import { PageContext } from '../page';
import { type SubmitFeedbackFormProps } from './FeedbackModalContainer';

interface FeedbackModalProps {
  showModal: boolean;
  closeModal: () => void;
  onSubmit: (props: SubmitFeedbackFormProps) => void;
}

const modalContentStyle = {
  border: '0px',
  padding: '0px',
  width: '600px',
  background: 'none',
  filter: 'drop-shadow(6px 4px 4px #00000077)',
};

const FeedbackModal: React.FC<FeedbackModalProps> = ({
  showModal,
  closeModal,
  onSubmit,
}) => {
  const maxMessageLen = 320;
  const [messageLen, setMessageLen] = useState(0);
  const { csrf, path, pushAlert } = useContext(PageContext);
  const csrfTokenName = '_csrf'; // this is mostly aspirational so we can stop accessing cookies clientside and requiring extra custom form submission

  const messageLenTracker = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setMessageLen(event.target.value.length);
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity()) {
      onSubmit({
        form: form as HTMLFormElement & { message: { value: string }; subject: { value: string } },
        path,
        pushAlert,
      });
      closeModal();
    }
  };

  return (
    <Modal isOpen={showModal} contentStyle={modalContentStyle}>
      <Flex className='feedback-modal-flex'>
        <div className="issue-resolution-modal">
          <form name="form" onSubmit={handleSubmit}>
            {' '}
            <div className="title">
              TRIP CENTER HELPDESK
              <a onClick={closeModal}>
                <i
                  id="modalCancelled"
                  className="cancel pull-right glyphicon icon-white glyphicon-remove"
                ></i>
              </a>
            </div>
            <div className="content">
              <input type="hidden" name={csrfTokenName} value={csrf} />
              <div className="choices">
                <div className="row field-sep">
                  <div className="col-md-3 fs-label fs-label-hxs hidden-sm hidden-xs">
                    SUBJECT *
                  </div>
                  <div className="col-md-3 fs-label fs-label-xs visible-sm visible-xs">
                    SUBJECT *
                  </div>
                  <div className="col-md-9">
                    <input
                      type="text"
                      name="subject"
                      required
                      input-focus="true"
                    />
                  </div>
                </div>
                <div className="row field-sep">
                  <div className="col-md-3 fs-label fs-label-hxs hidden-sm hidden-xs">
                    MESSAGE *
                  </div>
                  <div className="col-md-3 fs-label fs-label-xs visible-sm visible-xs">
                    MESSAGE *
                  </div>
                  <div className="col-md-9">
                    <textarea
                      className="text-area"
                      id="message"
                      maxLength={maxMessageLen}
                      name="message"
                      onInput={messageLenTracker}
                      required
                      rows={3}
                    />
                    <span>
                      {320 - messageLen} characters remaining (320 max)
                    </span>
                  </div>
                </div>
                <div className="row field-sep">
                  <div className="col-md-3"></div>
                  <div className="col-md-9">* Required</div>
                </div>
              </div>

              <div className="action">
                <button
                  id="modalSubmitted"
                  className="btn btn-default"
                  type="submit"
                >
                  Send
                </button>
              </div>
            </div>
          </form>
        </div>
      </Flex>
    </Modal>
  );
};

export default FeedbackModal;
